import { LocalStorage } from "@polargold/pg-frontend-core";

import { version } from "../../../package.json";

/**
 * Thin namespacing adapter around `pg-frontend-core`'s `LocalStorage`: bakes in this app's
 * build mode and version, matching the original `versioned` flag (`false` omits the version
 * from the key - used for the access token, so a deploy doesn't force everyone to
 * re-authenticate; every other key stays versioned).
 */
export class StorageHelper extends LocalStorage {
    constructor(key: string, versioned = true) {
        super(key, {
            mode: import.meta.env.MODE,
            version: versioned ? version : undefined,
        });

        // `LocalStorage`'s methods aren't auto-bound - several call sites in this app
        // destructure them off the instance (`const { write, read } = new StorageHelper(...)`),
        // which would otherwise lose `this` when called later.
        this.write = this.write.bind(this);
        this.read = this.read.bind(this);
        this.remove = this.remove.bind(this);
        this.clear = this.clear.bind(this);
    }
}
